import React from 'react'
import {connect} from 'react-redux'
import {bool, func} from 'prop-types'
import {InputField} from '@agillic/agillic-ui'

import {onChangeHandler} from '../inputFields.helper'

import {setAuditMessageDirty, updateAuditMessage} from '../../login.actionCreators'
import localeData from '../../helpers/login.lang'
import {language} from '../../helpers/login.data'
import {validateAuditInput} from '../inputFields.validation'

const locale = localeData[language]

const Audit = ({isVisible, auditMessage, onUpdateAuditMessage, isAuditMessageDirty, onSetAuditMessageDirty}) => isVisible && (
  <InputField
    inputType='multipleLineText'
    value={auditMessage}
    placeholder={locale.auditPlaceholder()}
    onBlur={() => onSetAuditMessageDirty()}
    onChange={({target}) => onChangeHandler({target, onUpdate: onUpdateAuditMessage})}
    validation={validateAuditInput({auditMessage, isAuditMessageDirty})}
    uniqueID='audit'
    autofocus
  />
)

const mapStateToProps = ({loginReducer}) => ({
  auditMessage: loginReducer.auditMessage,
  isAuditMessageDirty: loginReducer.isAuditMessageDirty
})

const mapDispatchToProps = dispatch => ({
  onUpdateAuditMessage: value => dispatch(updateAuditMessage({auditMessage: value})),
  onSetAuditMessageDirty: value => dispatch(setAuditMessageDirty({value}))
})

Audit.propTypes = {
  isVisible: bool,
  onSubmit: func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(Audit)
